import { useDesignBoardPageState } from '@modules/design-board/component/context';
import { useStyles } from '@archipro-design/aria';
import { MobileShareBoardForm } from '@modules/design-board/component/share-modal/MobileShareBoardForm';
import * as S from './MobileShareBoardModal.style';
import type { DesignBoardWithDetailedPinsFragment } from '../../../../../generated/graphql';
import React, { useEffect } from 'react';
import { MobileCollaboratorsModal } from '@modules/design-board/component/manage-collaborators/MobileCollaboratorsModal';
import type { DesignBoardCollaborator } from '@modules/design-board/validation/types';
import BottomDrawer from '~/modules/detail/components/bottom-drawer/BottomDrawer';

interface MobileShareBoardModalProps {
    inviteModalTitle?: string;
    collaboratorsModalTitle?: string;
    currentBoardData: DesignBoardWithDetailedPinsFragment;
    collaborators: DesignBoardCollaborator[];
}

export const MobileShareBoardModal = ({
    inviteModalTitle = 'Share this board',
    collaboratorsModalTitle = 'Manage collaborators',
    currentBoardData,
    collaborators,
}: MobileShareBoardModalProps) => {
    const { dispatch, state } = useDesignBoardPageState();
    const { css } = useStyles();
    const closeModal = () => {
        // check if second drawer is closed to avoid closing the first drawer
        if (!state.isDrawerOpen) {
            dispatch({ type: 'CloseShareBoardModal' });
        }
    };

    useEffect(() => {
        dispatch({
            type: 'SetCurrentBoardPin',
            currentBoardData,
        });
    }, [dispatch, currentBoardData]);

    return (
        <>
            <BottomDrawer
                open={state.isShareBoardModalOpen}
                toggleModal={closeModal}
                title={inviteModalTitle}
            >
                <div className={css(S.ModalContent)}>
                    <MobileShareBoardForm
                        board={currentBoardData}
                        onClose={closeModal}
                    />
                </div>
            </BottomDrawer>
            <MobileCollaboratorsModal
                title={collaboratorsModalTitle}
                collaborators={collaborators}
            />
        </>
    );
};
